import React from 'react'
import { CellProps } from 'react-table'
import { Data } from '@amzn/aapn-react-components/dist/Table/table'
import { Trans, useTranslation } from 'react-i18next'
import { Text, useUID } from '@amzn/storm-ui'

export interface SingleTranslationMultiTextCellData extends Data {
  translationKey: string
}

export const SingleTranslationMultiTextCell: React.FunctionComponent<CellProps<SingleTranslationMultiTextCellData>> = (
  props: CellProps<SingleTranslationMultiTextCellData>,
): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Text>
      <Trans i18nKey={props.cell.value.translationKey} components={[<Text textColor="secondary" key={useUID(props.cell.value.translationKey)} />]} />
    </Text>
  )
}
